module.exports = __webpack_public_path__ + "static/media/Head_2.617d541c.jpg";